var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMigo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:#7085b4;}.cls-1,.cls-11,.cls-12,.cls-2,.cls-5,.cls-6,.cls-7{fill-rule:evenodd;}.cls-2,.cls-4{fill:#a0b2da;}.cls-4{stroke:#a0b2da;stroke-miterlimit:10;stroke-width:5.34px;}.cls-6{fill:#fff;}.cls-7{fill:#1a1a1a;}.cls-8{fill:#d8180e;}.cls-8,.cls-9{stroke:#000001;stroke-width:2.05px;}.cls-9{fill:#0f1b5e;}.cls-10{fill:#6c7fa9;}.cls-11{fill:#9baacf;}.cls-12{fill:#191818;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "migo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "leg_right",
    className: "cls-1",
    d: "M638.76,529.9c-44.49,29.47-46.9,80.27-27.49,111.67s88.61-25.86,88,29.66c32.07-3.89,45.16,32.2,16.63,41-24.34,7.47-64.06.27-77.55-12.55-24.18-23-41.08,14-57.18,11.7-36.81-5.2-4.52-44.69-2.63-59.34,2.74-21.2-3.93-57-35-137.37C516.77,445.17,685.55,498.92,638.76,529.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "leg_left",
    className: "cls-1",
    d: "M370.71,536.53c44.21,29.89,35.62,72.75,15.91,104s-88.36-26.71-88.32,28.82c-32-4.2-45.47,31.76-17,40.79,24.27,7.71,64.06.88,77.66-11.81,24.4-22.76,40.95,14.37,57.07,12.25,36.86-4.85,4.95-44.65,3.2-59.31-2.54-21.23,4.47-57,36.28-137C483,445,324.22,505.1,370.71,536.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hair",
    className: "cls-2",
    d: "M498.61,18.82c26.18.12,50.5,31.91,51.76,88.13C568,77.2,588.21,73.1,604.87,77.77s24.25,24.2,25.43,51.44c29.26-41.1,66-64.14,86.87-52.57,23.58,13.06,18,65.3-12.38,116.68-.65,1.09-1.3,2.17-2,3.25,19.78-6.53,36.44-6,45.55,3.2,14.37,14.47,5.8,46.21-18.71,78.65,38.63-8.25,70.76-3.22,77.83,14.28,8,19.69-18.5,48.52-60.72,68.37,18.63,9.08,29.86,20.95,29.46,33.64-.81,26.26-51.07,44.6-112.32,44.31l-334.63-1.6C268,437.13,218,418.31,217.39,392c-.27-12.7,11.08-24.46,29.78-33.36-42-20.25-68.19-49.33-60-68.94,7.23-17.44,39.4-22.16,78-13.54-24.19-32.67-32.47-64.49-18-78.82,9.19-9.09,25.86-9.48,45.58-2.77-.65-1.08-1.3-2.17-1.93-3.26-29.93-51.68-35-104-11.26-116.8,21-11.37,57.49,12,86.35,53.39,1.45-27.22,9.24-46.67,25.93-51.19s38.11-1.43,55.45,28.48C449,49,472.43,18.69,498.61,18.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hand_left",
    className: "cls-1",
    d: "M809,421.29c-25.43,12.37-50.73,38.69-37.41,53.27,5.44,6,25.52-10.47,34.39.89,5.51,7.05-6.63,32.74,10.51,38.72s11.71-38.63,21.9-41.11c10.36-2.52,23.87,44.69,37.48,31.12,15.31-15.27-24.33-44.08-16.87-52.3,5.49-6,29.63,18.11,36.63,3.83,7.26-14.82-21.06-31.57-45.14-38.16a97,97,0,0,0-20.33-53.35c-12.82-16.28-30.84-28-52-31.47a80,80,0,0,0-15.38-1c-17.14.5-29.08-1.22-40.13-7.56-12.51-7.19-25.85-20.69-44.85-43.22a111.6,111.6,0,0,0-9.42-10c-23.57-21.81-52.46-29.27-81.16-26.41-27.2,2.71-54.14,15-75.62,33.1-22.94,19.35,11.28,45,26.83,31.85,15.32-12.92,34.22-21.65,53-23.52,17.31-1.72,34.62,2.66,48.54,15.55a72,72,0,0,1,6,6.22c22.09,26.2,38.47,42.39,55.93,52.42,18.92,10.86,37.2,13.87,62.17,13.14a39.12,39.12,0,0,1,7.43.51c10.33,1.7,19.34,7.67,25.92,16A55.45,55.45,0,0,1,809,421.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hand_right",
    className: "cls-1",
    d: "M187.6,428.33c26.55,9.73,54.38,33.36,42.6,49.21-4.81,6.48-26.44-7.84-34.12,4.36-4.77,7.58,9.9,31.91-6.55,39.59S174,484.24,163.59,482.8c-10.56-1.46-19.23,46.88-34.14,34.75-16.77-13.64,19.76-46.31,11.5-53.74-6.07-5.45-27.64,21-36,7.51-8.73-14,17.75-33.53,41-42.52a97.05,97.05,0,0,1,14.83-55.14c11.11-17.49,27.85-31,48.54-36.55a79.75,79.75,0,0,1,15.2-2.56c17.09-1.24,28.8-4.16,39.16-11.58,11.72-8.41,23.62-23.19,40.25-47.53a111.66,111.66,0,0,1,8.37-10.86c21.24-24.08,49.23-34.42,78.07-34.48,27.34,0,55.39,9.45,78.58,25.3,24.78,16.93-6.68,45.86-23.48,34.39-16.54-11.3-36.22-18.07-55.12-18-17.39,0-34.16,6.15-46.71,20.38a69.18,69.18,0,0,0-5.32,6.79C319,327.21,304.33,345,288,356.72c-17.72,12.72-35.61,17.56-60.52,19.36a38.18,38.18,0,0,0-7.34,1.25c-10.11,2.73-18.47,9.58-24.17,18.56A55.41,55.41,0,0,0,187.6,428.33Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "body"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 500.2,
    cy: 336.8,
    r: 238.07,
    transform: "translate(-91.65 452.34) rotate(-45)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 500.27,
    cy: 320.96,
    rx: 222.23,
    ry: 237.54,
    transform: "translate(176.93 819.71) rotate(-89.73)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ears"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M378.19,104.62c-2.48-68.81-143-106.4-167-89.67S216,167.56,274,193.61,380.48,168.19,378.19,104.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M361.56,112.79c2.12-54-112.21-83.49-131.06-70.36s3.82,119.74,49.34,140.18c17.47,7.85,35.38,9.07,47.27-.45,16.55-13.24-40-12.8-13.41-60.47C329.87,92.71,360.65,136.14,361.56,112.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M619.53,105.77c3.14-68.78,144-105,167.89-88.06s-6.32,152.55-64.58,178S616.64,169.32,619.53,105.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M639.46,104.05c-1.6-54,113-82.42,131.73-69.11s-5,119.7-50.67,139.71c-17.55,7.68-35.48,8.73-47.27-.9-16.42-13.41,46.91-25.43,14-60.35C660.28,84.82,640.15,127.41,639.46,104.05Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "lips"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M495.3,497.88c127.28.92,189.87-110.12,133.23-85.25-61.57,27-200.77,26.58-262.24-1.48C310,385.46,368,497,495.3,497.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M495.34,492c109.67.8,170.55-90.43,121.75-69-53.06,23.3-189.52,22.42-242.48-1.76C326.12,399.1,385.67,491.2,495.34,492Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M585.2,432.47a29.93,29.93,0,0,0,2.92,7c2,3.56,4.62,5.95,8.7,5.88a62.87,62.87,0,0,0,21.52-4.17,8.81,8.81,0,0,0,5.87-8.71,43.74,43.74,0,0,0-1.37-11.66,53.32,53.32,0,0,0-5.75,2.17C608.44,426.8,597.56,430,585.2,432.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M541.4,438.35a29.93,29.93,0,0,0,1.81,6.77c1.47,3.82,3.73,6.55,7.78,7.06a62.7,62.7,0,0,0,21.89-1.07,8.82,8.82,0,0,0,7.06-7.77,47.47,47.47,0,0,0,.48-9.94A383.21,383.21,0,0,1,541.4,438.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M498.1,439.93a31.3,31.3,0,0,0,1.35,6.35c1.23,3.9,3.31,6.76,7.33,7.52a62.51,62.51,0,0,0,21.91.29,8.83,8.83,0,0,0,7.53-7.33,51,51,0,0,0,1.06-8.11C524.54,439.54,511.34,440,498.1,439.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M406.72,431.26a29.83,29.83,0,0,1-3,6.89c-2.05,3.54-4.7,5.88-8.78,5.75a62.69,62.69,0,0,1-21.46-4.48,8.81,8.81,0,0,1-5.75-8.79,43.93,43.93,0,0,1,1.51-11.52,54.93,54.93,0,0,1,5.37,2.13C383.3,425.21,394.26,428.54,406.72,431.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M450.45,437.73a30.3,30.3,0,0,1-1.91,6.71c-1.52,3.79-3.82,6.48-7.88,6.94A62.65,62.65,0,0,1,418.79,450a8.8,8.8,0,0,1-6.94-7.88,46,46,0,0,1-.34-9.87A381.71,381.71,0,0,0,450.45,437.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M493.72,439.9a30.1,30.1,0,0,1-1.44,6.33c-1.28,3.88-3.41,6.71-7.43,7.42a62.8,62.8,0,0,1-21.92,0,8.81,8.81,0,0,1-7.42-7.43,50.67,50.67,0,0,1-.94-8.09C467.29,439.16,480.49,439.76,493.72,439.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M580.89,472.58c-.3-1-.56-1.95-.78-3-.88-4-.5-7.51,2.6-10.18a62.89,62.89,0,0,1,18.85-11.18,8.83,8.83,0,0,1,10.18,2.6c.37.43.74.85,1.1,1.28A164.24,164.24,0,0,1,580.89,472.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M541.75,486.7A30.73,30.73,0,0,1,541,480c0-4.08,1.08-7.45,4.67-9.4a62.66,62.66,0,0,1,20.76-7,8.81,8.81,0,0,1,9.41,4.67,53.39,53.39,0,0,1,2.74,5.45A188.71,188.71,0,0,1,541.75,486.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M498.2,492a32.2,32.2,0,0,1,.09-5.63c.4-4.06,1.85-7.29,5.62-8.87a62.72,62.72,0,0,1,21.39-4.8,8.8,8.8,0,0,1,8.86,5.62,45.81,45.81,0,0,1,3.1,9.4A192.86,192.86,0,0,1,498.2,492Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M410.08,471.34c.32-1,.59-1.95.83-2.95.93-4,.61-7.51-2.45-10.21a62.65,62.65,0,0,0-18.69-11.45,8.81,8.81,0,0,0-10.21,2.45c-.38.41-.76.83-1.13,1.26A164.7,164.7,0,0,0,410.08,471.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M449,486a31.17,31.17,0,0,0,.82-6.69c.08-4.08-1-7.46-4.52-9.47a63,63,0,0,0-20.67-7.31,8.82,8.82,0,0,0-9.48,4.53,52.38,52.38,0,0,0-2.81,5.41A187.9,187.9,0,0,0,449,486Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M492.48,491.94a32,32,0,0,0,0-5.62c-.35-4.07-1.75-7.32-5.49-8.95a62.57,62.57,0,0,0-21.32-5.11,8.81,8.81,0,0,0-8.95,5.49,46.85,46.85,0,0,0-3.23,9.35A191.71,191.71,0,0,0,492.48,491.94Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eyes"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OESQ"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M400.18,359.39a100.26,100.26,0,1,0-99.77-100.74A100.46,100.46,0,0,0,400.18,359.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M400.25,347.31a88.18,88.18,0,1,0-87.76-88.6A88.35,88.35,0,0,0,400.25,347.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M400.38,319.53a60.4,60.4,0,1,0-60.12-60.69A60.51,60.51,0,0,0,400.38,319.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M400.46,301.47a42.34,42.34,0,1,0-42.13-42.54A42.42,42.42,0,0,0,400.46,301.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M438.07,244a20.25,20.25,0,1,0-20.14-20.34A20.29,20.29,0,0,0,438.07,244Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ODIR"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 601.46,
    cy: 260.09,
    r: 100.25
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M601,348.27a88.18,88.18,0,1,0-87.76-88.6A88.35,88.35,0,0,0,601,348.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M601.17,320.49a60.4,60.4,0,1,0-60.11-60.69A60.51,60.51,0,0,0,601.17,320.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M601.26,302.43a42.34,42.34,0,1,0-42.14-42.54A42.42,42.42,0,0,0,601.26,302.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M638.87,245a20.25,20.25,0,1,0-20.15-20.34A20.29,20.29,0,0,0,638.87,245Z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "_1",
    "data-name": 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "text"
  }, /*#__PURE__*/React.createElement("g", {
    id: "word"
  }, /*#__PURE__*/React.createElement("g", {
    id: "M"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M175.12,770.86l26.22,92.65,26-87.61,57.18-1.74q11.46,108,13.2,216L242,986.63V870.29L224,939.45H175.12l-14.57-75.94-5,117.88-52-3.31,9.69-203.84Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "G"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M532.89,835.14q-9.33-32.43-31.67-32.31a37.61,37.61,0,0,0-10.49,1.54q-30.89,8.71-34.18,59-.19,2.91-.2,8.35,0,43.28,31.87,57.18a44.69,44.69,0,0,0,17.4,4.07q21.35,0,32.31-28.93l-39.77-4.68,9.94-35.35,84.67,8.18q-6.59,95.53-51.45,104.41a140.52,140.52,0,0,1-27.6,2.71,146.4,146.4,0,0,1-61.18-13.8Q408.47,945.66,404.39,881c-.27-4.15-.4-8.92-.4-14.37q0-49.9,22.92-79.82,25.44-33.4,74-33.41a145.9,145.9,0,0,1,18.45,1.17q56.1,7.21,61.74,64.63Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "I"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M379.31,753.8l-7.78,236.36-51.26-7q3.87-57.17,3.88-113.6t-3.88-112.27Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "esc"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M824.19,969a32.79,32.79,0,0,1-5.42-16.91,24.21,24.21,0,0,1,3.87-13q8.34-13.2,22.05-14.37t24,11.27a27.52,27.52,0,0,1,7.16,17.87A24.3,24.3,0,0,1,874.5,962,29.09,29.09,0,0,1,855,980.42a22.24,22.24,0,0,1-7,1.17Q836.38,981.59,824.19,969Zm5.64-75a864.26,864.26,0,0,0,4.27-93.39q0-32.83-1.54-71.47l63.89,13.2q-17.67,95.76-28.54,159.25Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "eye_word",
    "data-name": "eye word"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "eye_circle_blue",
    "data-name": "eye circle blue",
    className: "cls-10",
    cx: 709.81,
    cy: 874.17,
    r: 106.94
  }), /*#__PURE__*/React.createElement("path", {
    id: "eye_circle_white",
    "data-name": "eye circle white",
    className: "cls-6",
    d: "M709.39,968.21a94.07,94.07,0,1,0-93.6-94.53v.07A94.24,94.24,0,0,0,709.39,968.21Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eye_of_word",
    "data-name": "eye of word"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M709.39,938.61a64.44,64.44,0,1,0-64.11-64.76V874A64.63,64.63,0,0,0,709.39,938.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M709.59,919.31a45.17,45.17,0,1,0-45-45.39v0A45.24,45.24,0,0,0,709.59,919.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M749.71,858a21.6,21.6,0,1,0-21.5-21.7A21.59,21.59,0,0,0,749.71,858Z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMigo);
export default __webpack_public_path__ + "static/media/migo.cc6cb98b321a180791b5cfe9321e0848.svg";
export { ForwardRef as ReactComponent };